import React from 'react';
import { ApprovedUser } from '@/schemas/admin.types';
import UserCard from '../../cards/UserCard';

interface ApprovedUsersCardListProps {
  users: ApprovedUser[];
  onDeleteUser?: (userId: string) => void;
  deleting?: string | null;
  userVideoCountMap?: Map<string, number>;
}

/**
 * ApprovedUsersCardList - Mobile-optimized card list for approved users
 * 
 * Displays approved users in a card-based layout with search functionality
 * optimized for mobile viewing.
 */
const ApprovedUsersCardList: React.FC<ApprovedUsersCardListProps> = ({
  users,
  onDeleteUser,
  deleting = null,
  userVideoCountMap
}) => {

  // Empty state for no users
  if (users.length === 0) {
    return (
      <div className="text-center py-8">
        <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-1">No approved users</h3>
        <p className="text-gray-500">Users will appear here once they are approved</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className='flex justify-between items-center px-4'>
        <span>Name</span>
        <span className='pr-12'>Role</span>
      </div>
      {users.map((user) => (
        <UserCard
          key={user.id}
          user={user}
          type="approved"
          onDelete={onDeleteUser}
          isDeleting={deleting === user.id}
          videoCount={userVideoCountMap?.get(user.email) || 0}
        />
      ))}
    </div>
  );
};

export default ApprovedUsersCardList;
